export default __webpack_public_path__ + "locales/bg/PortalUnavailable.json?hash=eb4b5ee5f1cba2c82a32950fcc3b390c";